import { Component, Inject, OnInit } from '@angular/core';
import { Member } from 'src/app/classes/member';
import { MemberService } from 'src/app/services/member.service';
import { forkJoin, map, Observable } from 'rxjs';
import { SectionService } from 'src/app/services/section.service';
import { Section } from 'src/app/classes/section';
import { FileService } from 'src/app/services/file.service';
import { Group } from 'src/app/classes/fileInfo';
import { Environment } from 'src/app/classes/environment';
import { DocumentExchangeService } from 'src/app/services/document-exchange.service';
import { DocumentExchangeCategory } from 'src/app/classes/document-exchange';
import { accordeonMe } from 'src/app/animations';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/classes/user';


@Component({
	selector: 'app-member-management',
	templateUrl: './member-management.component.html',
	styleUrls: [ './management-interface.css', 'accordeon-ui.scss' ],
	animations: [ accordeonMe ],
})
export class MemberManagementComponent implements OnInit {


	elements: Member[] = [];
	currentFilter = "";
	filteredElements: Member[] = [];
	expandedElementId = "";

	bLoading = true;

	sections: Section[] = [];
	groups: Group[] = [];
	documentExchangeCategories: DocumentExchangeCategory[] = [];

	sortingField = 'mitgliedsname';
	sortingAsc = true;

	canBeContact: { [key:string]: User[] } = {};
	usernames: { [key:string]: string } = {};


	constructor(
		private memberService: MemberService,
		private sectionService: SectionService,
		private fileService: FileService,
		@Inject( "environment" ) public environment: Environment,
		private documentExchangeService: DocumentExchangeService,
		private userService: UserService
	) {}


	ngOnInit() {

		const obss: Observable<boolean>[] = [
			this.fileService.getGroups().pipe( 
				map( groups => {
					this.groups = groups;
					return true;
				} )
			),
			this.userService.getAll().pipe(
				map( users => {
					
					for( let user of users ) {

						const arr: string[] = [];
						if( user.ebeVorname ) arr.push( user.ebeVorname );
						if( user.ebeName ) arr.push( user.ebeName );
						this.usernames[ user.ebeId ] = ( arr.join( " " ) || user.ebeId );

						// only non-admin users can be Ansprechpartner
						if( !user.gruppen || !user.gruppen.includes( 'ADMIN' ) ) {
							if( !this.canBeContact[ user.mitgliedId ] ) this.canBeContact[ user.mitgliedId ] = [];
							this.canBeContact[ user.mitgliedId ].push( user );
						}

					}
	
					return true;

				} )
			)
		];
		if( this.environment.features.sparten ) {
			obss.push( this.sectionService.getAll().pipe(
				map( sections => {
					this.sections = sections;
					return true;
				})
			) );
		}
		if( this.environment.features.austausch ) {
			obss.push( this.documentExchangeService.getDocumentExchangeCategories().pipe(
				map( deCategories => {
					if( !deCategories ) return false;
					this.documentExchangeCategories = deCategories;
					return true;
				})
			) );
		}


		forkJoin( obss ).subscribe( results => {

			for( const result of results ) {
				if( !result ) {
					this.bLoading = false;
					return;
				}
			}

			this.memberService.getAll().subscribe( members => {
				this.bLoading = false;
				this.elements = members;
				this.sortElements();
			});
			
		});

	}


	sortColumn( field: string ) {

		if( this.sortingField === field ) {
			this.sortingAsc = !this.sortingAsc;
		} else {
			this.sortingField = field;
			this.sortingAsc = true;
		}

		this.sortElements();

	}

	sortElements() {

		this.elements.sort( ( a, b ) => {

			const valueA = (a[this.sortingField] || '').toString();
			const valueB = (b[this.sortingField] || '').toString();
		
			return this.sortingAsc ? valueA.localeCompare( valueB ) : valueB.localeCompare( valueA );

		});

		this.applyFilter();

	}

	clickOnRow( elementId: string ) {

		const bPrevious = !!this.expandedElementId;

		this.expandedElementId = ( this.expandedElementId == elementId ) ? "" : elementId;

		if( bPrevious && this.expandedElementId ) {
			setTimeout( () => {
				const elem = window.document.getElementById( "elementRow_" + elementId );
				if( elem ) {
					elem.scrollIntoView( { behavior: "smooth", block: "start" } );
				}
			}, 500 );
		}

	}


	onFilterChanged( event: Event ) {

		this.currentFilter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase(); 
		this.applyFilter();

	}

	private applyFilter() {

		this.filteredElements = this.elements.filter( u => {

			for( const searchField of [ "mitgliedsname" ] ) {

				if( !u[ searchField ] ) continue;
				const str = ("" + u[ searchField ]).toLowerCase();
				if( str.includes( this.currentFilter ) ) return true;

			}

			return false;

		});

	}

}


